<template>
  <div>
    <div class="flex flex-wrap justify-between items-center mb-4">
      <h4>Language</h4>
      <vs-button @click="addpopup = true">
        Add
      </vs-button>
    </div>
    <vs-card class="cstm_vx_card">
      <table
        v-if="languageProps.length > 0"
        :data="languageProps"
        class="light_blue_table w-full"
      >
        <tbody>
          <tr :key="indextr" v-for="(item, indextr) in languageProps">
            <td :data="languageProps[indextr].language">
              {{ languageProps[indextr].language }}
            </td>
            <td class="text-right">
              <vs-dropdown>
                <vs-button
                  class="btn-drop"
                  type="flat"
                  icon="more_vert"
                ></vs-button>
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    @click="handleedit(indextr)"
                  >
                    Edit
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="remove(indextr)"
                  >
                    Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="languageProps.length == 0" class="text-center">
        No Language found
      </div>
    </vs-card>

    <vs-popup
      classContent="popup-example"
      title="Delete"
      :active.sync="deletepopup"
    >
      <h4>Are you sure to delete this ?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="handleDelete">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="deletepopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>

    <vs-popup
      classContent="popup-example"
      title="Add Language"
      :active.sync="addpopup"
    >
      <form data-vv-scope="add">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <v-select
              v-validate="'required'"
              name="language"
              :options="languageList"
              v-model="language"
              label="language"
              :reduce="(item) => item"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
            <span v-show="errors.has('edit.language')" class="text-danger">{{
              errors.first("edit.language")
            }}</span>
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSave">Save</vs-button>
        <vs-button type="border" color="danger" @click="addpopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>

    <vs-popup
      classContent="popup-example"
      title="Edit Language"
      :active.sync="editpopup"
    >
      <form data-vv-scope="edit">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <v-select
              v-validate="'required'"
              name="language"
              :options="languageList"
              :value="(item) => item.id"
              label="language"
              v-model="edit"
              :reduce="(item) => item"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
            <span v-show="errors.has('edit.language')" class="text-danger">{{
              errors.first("edit.language")
            }}</span>
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleUpdate">Save</vs-button>
        <vs-button type="border" color="danger" @click="editpopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import { GetLanguageList } from '@/api/common'
import vSelect from 'vue-select'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { TeacherUpdate } from '@/api/teacher'

export default {
  name: 'email',
  components: {
    vSelect
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Teachers')
    }
  },
  mixins: [PermissionMiddleware],
  props: {
    languageProps: {
      required: true,
      type: Array,
      default: () => []
    },
    havePermission: {
      default: false
    }
  },
  watch: {
    languageProps: {
      deep: true,
      immediate: true,
      handler () {
        this.languageAvailability = this._.cloneDeep(this.languageProps)
      }
    }
  },
  data () {
    return {
      languageAvailability: [],
      addpopup: false,
      deletepopup: false,
      editpopup: false,
      language: null,
      edit: {
        created_at: null,
        deleted_at: null,
        id: null,
        language: null,
        short_name: null,
        updated_at: null
      },
      editIndex: null,
      deleteindex: false,
      languageList: []
    }
  },

  mounted () {
    this.getLanguage()
  },
  methods: {
    handleSave () {
      this.$validator.validateAll('add').then((result) => {
        if (result) {
          const payload = this.language
          this.languageAvailability.push(payload)
          this.addpopup = false
          
          this.handleLanguageSave()
        }
      })
    },
    async handleLanguageSave () {
      try {
        const customer_id = localStorage.getItem('customer_id')
       
        const payload = {
          updateField: {
            languages: this.languageAvailability
          }
        }
        const { data } = await TeacherUpdate(
          payload,
          JSON.parse(localStorage.getItem('userInfo')).id,
          customer_id
        )
        this.addpopup = false
        this.editpopup = false
        this.deletepopup = false
        this.language = null

        this.$emit('setAfterUpdate', data)
        this.showSuccessMessage('Success', 'Updated Successfully', 'success')
      } catch (error) {
        console.log(error)
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    },
    handleedit (index) {
      this.editpopup = true

      this.edit = this.languageAvailability[index]
      this.editIndex = index
    },
    handleUpdate () {
      this.$validator.validateAll('edit').then((result) => {
        if (result) {
          const __temp = this.languageAvailability
          __temp[this.editIndex] = this.edit
          this.languageAvailability = __temp
        }
        this.handleLanguageSave()
      })
    },
    handleDelete () {
      this.languageAvailability.splice(this.deleteindex, 1)
      this.handleLanguageSave()
    },
    remove (index) {
      if (this.languageAvailability.length > 1) {
        this.deletepopup = true
        this.deleteindex = index
      } else {
        this.$vs.notify({
          title: 'warning',
          text: 'Minimum one language must be add',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      }
    },
    async getLanguage () {
      try {
        const { data } = await GetLanguageList()
        const list = data.data.languages_list
        this.languageList = list
      } catch (e) {
        //
      }
    }
  }
}
</script>
  